import { Product } from '@virginexperiencedays/dy';
import { addToDataLayer } from '../../../tracking/gtm/utils';
import { hitImpression } from '../../search/tracking';

const LIST = 'gift-finder-results';

type TrackProductClickArgs = {
  product: Product;
  position: number;
};

/*
 * Used to report product clicks to GTM
 * @param {Product} product - Product object - IMPORTANT: This is DY product not regular Product type
 * @param {number} position - Position of product in list
 */
export const trackProductClick = ({ product, position }: TrackProductClickArgs) => {
  addToDataLayer({
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: LIST,
        },
        products: [
          {
            position,
            ...hitImpression(
              {
                ...product,
                price: {
                  displayPrice: product.displayPrice,
                },
              },
              position,
              LIST
            ),
          },
        ],
      },
    },
  });
};

type TrackComponentClickArgs = {
  component: string;
  slug: string;
  label: string;
};

export const trackComponentClick = ({ component, slug, label }: TrackComponentClickArgs) => {
  addToDataLayer({
    event: 'userInteraction',
    eventCategory: 'Gift Finder',
    eventAction: 'Clicked ' + component + ' | ' + slug,
    eventLabel: label,
  });
};

type TrackSideEffectArgs = {
  action: string;
  label?: string;
};

/*
 * Used to report side effects to GTM, ie. no results page rendered, or price upperbound had to be increased to return certain amount of results
 * @param {string} label - Location from which clicked
 * @param {string} action - Action describing cause - can be empty
 */
export const trackSideEffect = ({ action, label = '' }: TrackSideEffectArgs) => {
  addToDataLayer({
    event: 'genericEvent',
    eventCategory: 'Gift Finder',
    eventAction: action,
    eventLabel: label,
  });
};
